var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThreads(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "42.983%",
    cy: "0%",
    fx: "42.983%",
    fy: "0%",
    r: "119.324%",
    gradientTransform: "matrix(.20986 .83801 -.98643 .18147 .34 -.36)",
    id: "odvov9dkea"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9D262",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F6A650",
    offset: "22.135%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F14E2C",
    offset: "50.167%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#98069F",
    offset: "82.431%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E18D1",
    offset: "100%"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.675 392.999a9.668 9.668 0 0 0-.365-.167c-.216-3.982-2.384-6.262-6.024-6.286h-.05c-2.176 0-3.987.933-5.102 2.63l2.002 1.379c.833-1.268 2.14-1.538 3.102-1.538h.033c1.199.008 2.103.357 2.688 1.04.426.496.711 1.182.852 2.048a15.26 15.26 0 0 0-3.44-.166c-3.461.2-5.686 2.226-5.536 5.041.075 1.428.784 2.657 1.995 3.46 1.024.678 2.343 1.01 3.713.934 1.81-.1 3.23-.792 4.221-2.06.752-.962 1.228-2.21 1.438-3.781.863.522 1.502 1.21 1.855 2.036.6 1.406.636 3.715-1.241 5.597-1.645 1.65-3.622 2.362-6.61 2.385-3.313-.025-5.82-1.092-7.45-3.171-1.525-1.947-2.314-4.76-2.343-8.359.029-3.6.818-6.412 2.344-8.359 1.63-2.079 4.135-3.146 7.45-3.17 3.338.024 5.888 1.096 7.58 3.186.83 1.024 1.455 2.313 1.867 3.815l2.346-.628c-.5-1.85-1.286-3.443-2.356-4.764-2.17-2.679-5.342-4.051-9.43-4.08h-.016c-4.079.028-7.216 1.406-9.323 4.095-1.875 2.393-2.842 5.722-2.875 9.895v.02c.033 4.173 1 7.503 2.875 9.895 2.107 2.689 5.244 4.067 9.323 4.095h.017c3.626-.025 6.183-.978 8.288-3.09 2.756-2.763 2.673-6.226 1.765-8.352-.652-1.524-1.894-2.763-3.593-3.58zm-6.261 5.909c-1.517.085-3.093-.598-3.17-2.062-.058-1.085.769-2.296 3.263-2.44.286-.017.566-.025.841-.025.906 0 1.754.088 2.524.257-.287 3.603-1.973 4.188-3.458 4.27z",
    transform: "translate(-21 -380.021)",
    fill: "url(#odvov9dkea)",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreads);
export default __webpack_public_path__ + "static/media/threads.2d0f23a65cbc21a6a4824bbd931b432a.svg";
export { ForwardRef as ReactComponent };